/** @format */

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import sun from '../../assets/animations/sun';

function SunSpinner({ height, width }) {
  return (
    <Box
      sx={{
        height,
        width,
      }}
    >
      <DotLottieReact
        data={sun}
        loop
        autoplay
        speed={3}
        mode="bounce"
        height={height}
        width={width}
      />
    </Box>
  );
}

SunSpinner.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

export default SunSpinner;
